import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29515ae9")

_pushScopeId("data-v-29515ae9")
const _hoisted_1 = {
  class: "modal fade language-handler-modal",
  id: "modal_add_language",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "d-flex justify-content-center py-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-file-earmark-arrow-down-fill" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Import Keys ")
const _hoisted_11 = {
  key: 0,
  class: "spinner-grow",
  style: {"width":"1.5rem","height":"1.5rem"},
  role: "status"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-file-earmark-arrow-up-fill" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Export Keys ")
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "icon-holder" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-file-earmark-plus-fill" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Add Key ")
const _hoisted_16 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_17 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_18 = { class: "input-item el-input__inner" }
const _hoisted_19 = { class: "align-items-center fs-6 fw-bold d-block" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "text-wrapper m-0"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-upload",
  style: {"text-align":"right","float":"right"}
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "modal-footer flex-center"
}
const _hoisted_25 = {
  key: 0,
  class: "spinner-grow",
  style: {"width":"1.5rem","height":"1.5rem"},
  role: "status"
}
const _hoisted_26 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, { ref: "addLanguageForm" }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t("message.ADD")} ${_ctx.$t("message.LANGUAGE")}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  (_ctx.$can('import_language') && !_ctx.showImportInputs)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn p-0",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showImportInputs = true))
                      }, [
                        _hoisted_9,
                        _hoisted_10
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$can('export_language') && !_ctx.showImportInputs)
                    ? (_openBlock(), _createBlock("button", {
                        key: 1,
                        class: "btn p-0",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportKeys())),
                        disabled: _ctx.disableExportBtn
                      }, [
                        (_ctx.disableExportBtn)
                          ? (_openBlock(), _createBlock("div", _hoisted_11))
                          : _createCommentVNode("", true),
                        _hoisted_12,
                        _hoisted_13
                      ], 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.$can('add_language_key') && !_ctx.showImportInputs)
                    ? (_openBlock(), _createBlock("button", {
                        key: 2,
                        class: "btn p-0",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addLanguageKey()))
                      }, [
                        _hoisted_14,
                        _hoisted_15
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.showImportInputs)
                  ? (_openBlock(), _createBlock("div", _hoisted_16, [
                      _createVNode("label", _hoisted_17, _toDisplayString(`${_ctx.$t("message.CHOOSE")}
                                ${_ctx.$t("message.FILE")}`), 1),
                      _createVNode("div", _hoisted_18, [
                        _createVNode("label", _hoisted_19, [
                          (_ctx.fileName == '')
                            ? (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(`${_ctx.$t("message.CHOOSE")}
                                            ${_ctx.$t("message.FILE")}`), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString(_ctx.fileName), 1))
                        ]),
                        _createVNode(_component_el_button, {
                          type: "info",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.triggerFile())),
                          plain: "",
                          class: "px-2 py-2 mx-1 btn-custom"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("message.UPLOAD")) + "  ", 1),
                            _hoisted_22
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_23,
                      _createVNode("input", {
                        class: "form-control",
                        ref: "inputFile",
                        id: "formFileSm",
                        style: {"display":"none"},
                        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
                        type: "file",
                        accept: "application/json"
                      }, null, 544),
                      _createVNode(_component_Select, {
                        class: "mt-3",
                        name: "localeKey",
                        target: "localeKey",
                        label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.LANGUAGE')}`,
                        localeKey: _ctx.localeKey,
                        "onUpdate:localeKey": _cache[6] || (_cache[6] = ($event: any) => (_ctx.localeKey = $event)),
                        selectData: _ctx.locales,
                        value: _ctx.localeKey,
                        clearable: true,
                        required: false
                      }, null, 8, ["label", "localeKey", "selectData", "value"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.showImportInputs)
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode("button", {
                    class: "btn btn-white me-3",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showImportInputs = false))
                  }, _toDisplayString(_ctx.$t("message.BACK")), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-custom",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitLanguageForm())),
                    disabled: _ctx.disableExportBtn
                  }, [
                    (_ctx.disableExportBtn)
                      ? (_openBlock(), _createBlock("div", _hoisted_25))
                      : _createCommentVNode("", true),
                    _createVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("message.SUBMIT")), 1)
                  ], 8, ["disabled"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 512)
      ])
    ])
  ]))
})